const photoLocations = [
  { name: "CVS Pharmacy", link: "https://www.cvs.com/store-locator/", note: "Walk-in passport photos at most locations across NJ" },
  { name: "Walgreens", link: "https://www.walgreens.com/storelocator", note: "Appointment recommended, walk-ins accepted at many NJ locations" },
  { name: "UPS Store", link: "https://www.theupsstore.com/tools/find-a-store", note: "Also handles overnight shipping of documents from NJ" },
  { name: "FedEx Office", link: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Photos + shipping in one stop near NYC and Philadelphia" },
  { name: "Walmart", link: "https://www.walmart.com/store-finder", note: "Photo center at select locations in NJ" },
];

const airports = [
  { code: "EWR", name: "Newark Liberty International", address: "3 Brewster Rd, Newark, NJ 07114", link: "https://www.newarkairport.com/" },
  { code: "JFK", name: "John F. Kennedy International", address: "JFK Access Rd, Jamaica, NY 11430", link: "https://www.jfkairport.com/" },
  { code: "LGA", name: "LaGuardia Airport", address: "Ditmars Blvd & 94th St, Flushing, NY 11369", link: "https://www.laguardiaairport.com/" },
  { code: "ACY", name: "Atlantic City International", address: "101 Atlantic City International Airport, Egg Harbor Township, NJ 08234", link: "https://www.acairport.com/" },
  { code: "TTN", name: "Trenton-Mercer Airport", address: "1100 Terminal Circle Dr, Ewing Township, NJ 08628", link: "https://www.ttn.org/" },
];

const shippingOptions = [
  { name: "FedEx", locator: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Priority Overnight for document submission from NJ" },
  { name: "UPS", locator: "https://www.theupsstore.com/tools/find-a-store", note: "Next Day Air Early AM available throughout NJ" },
  { name: "USPS", locator: "https://tools.usps.com/find-location.htm", note: "Priority Mail Express with tracking from NJ locations" },
];

export default function NewJerseyStateResources() {
  return (
    <section id="resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">State Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            New Jersey Passport Resources
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Everything New Jersey travelers need — photo locations, shipping options, airports, vital records, and regional passport agencies.
          </p>
        </div>

        {/* Passport Photo Locations */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Passport Photo Locations</h3>
              <p className="text-gray-400 text-xs">Find a location near you — most offer walk-in service</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photoLocations.map((loc, i) => (
              <a
                key={i}
                href={loc.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{loc.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{loc.note}</p>
              </a>
            ))}
          </div>
          <div className="mt-4 bg-[#FEF9E7] border border-[#F6C344]/20 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#F6C344] text-lg"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-[#1A365D]">Photo requirements:</strong> 2&times;2 inches, white or off-white background, taken within the last 6 months. Most chain locations know the rules, but always double-check before submitting — a bad photo is the #1 reason passport applications get delayed.
            </p>
          </div>
        </div>

        {/* New Jersey Airports */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Major Airports Near New Jersey</h3>
              <p className="text-gray-400 text-xs">International departure points — verify passport validity before booking</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {airports.map((ap, i) => (
              <a
                key={i}
                href={ap.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-[#1A365D] text-white text-xs font-bold px-2 py-0.5 rounded">{ap.code}</span>
                    <h4 className="font-semibold text-[#1A365D] text-sm">{ap.name}</h4>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ap.address}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Two-column: Agency + Vital Records */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {/* Regional Passport Agencies */}
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Nearest Regional Passport Agencies</h3>
                <p className="text-gray-400 text-xs">For life-or-death emergencies &amp; travel within 14 days</p>
              </div>
            </div>
            <div className="space-y-5">
              <div>
                <h4 className="font-semibold text-[#1A365D] text-sm mb-1">New York Passport Agency</h4>
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">376 Hudson St<br/>New York, NY 10014</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">877-487-2778</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-time-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">Mon&ndash;Fri 10:00 AM &ndash; 3:00 PM (appointment required)</p>
                  </div>
                </div>
              </div>
              <div className="pt-4 border-t border-gray-200">
                <h4 className="font-semibold text-[#1A365D] text-sm mb-1">Philadelphia Passport Agency</h4>
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">200 Chestnut St, Room 130<br/>Philadelphia, PA 19106</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">877-487-2778</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-time-line text-gray-400 text-sm"></i>
                    </div>
                    <p className="text-gray-600 text-sm">Mon&ndash;Fri 8:00 AM &ndash; 3:00 PM (appointment required)</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                Regional agencies require proof of travel within 14 days (or 28 days if a visa is needed). Most New Jersey travelers find that using an approved courier like Fast Passport Center is faster and more convenient than visiting a regional agency in NYC or Philadelphia.
              </p>
            </div>
          </div>

          {/* New Jersey Vital Records */}
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">New Jersey Vital Records</h3>
                <p className="text-gray-400 text-xs">Birth certificates for passport applications</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              First-time passport applicants need a certified birth certificate. New Jersey birth records can be ordered online, by mail, or in person through the New Jersey Department of Health.
            </p>
            <a
              href="https://www.nj.gov/health/vital/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Order New Jersey Birth Certificate <i className="ri-external-link-line"></i>
            </a>
            <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Office of Vital Statistics &amp; Registry<br/>369 S Warren St, Trenton, NJ 08608</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Rush processing available — typically 2&ndash;3 weeks</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">$25 per certified copy + shipping</p>
              </div>
            </div>
          </div>
        </div>

        {/* Shipping Options */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Shipping &amp; Document Delivery</h3>
              <p className="text-gray-400 text-xs">Overnight options for getting documents to the processing center fast</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {shippingOptions.map((ship, i) => (
              <a
                key={i}
                href={ship.locator}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{ship.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ship.note}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom tip */}
        <div className="bg-[#0F2240] rounded-lg p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-4">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <h4 className="font-bold text-white text-base mb-2">Pro Tip for New Jersey Travelers</h4>
          <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
            New Jersey&apos;s proximity to both New York City and Philadelphia means residents have access to two of the busiest international airport hubs in the country (EWR, JFK, and LGA). The busiest passport months in New Jersey are May through August (summer travel) and November through January (holiday trips). Because of the dense population and high international travel volume, New Jersey sees significant passport processing delays during peak seasons. If your trip falls during these windows, start your expedited application at least 4&ndash;6 weeks early, even with courier service.
          </p>
        </div>
      </div>
    </section>
  );
}